const state = {
  lines: [
    {
      code: "west",
      title: "Metro West"
    },
    {
      code: "greaterWest",
      title: "Greater West"
    },
    {
      code: "northWest",
      title: "NorthWest"
    },
    {
      code: "citySouthWest",
      title: "City and SouthWest"
    },
    {
      code: "futureProjects",
      title: "Future Projects"
    }
  ],
  stations: {
    west: [
      "Example Station X",
      "Pyrmont",
      "The Bays Precinct",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Olympic Park",
      "Silverwater",
      "Clyde",
      "Parramatta",
      "Westmead"
    ],
    greaterWest: [],
    northWest: [],
    citySouthWest: [],
    futureProjects: []
  },
  selectedLine: {},
  selectedStations: [],
  zones: [
    {
      code: "commercial",
      title: "Commercial",
      icon: "img/icons/projectIcon/commercial_icon.png",
      path: "/commercial"
    },
    {
      code: "reporting",
      title: "Reporting",
      icon: "img/icons/projectIcon/report_icon.png",
      path: "/reporting"
    },
    {
      code: "design",
      title: "Design",
      icon: "img/icons/projectIcon/design_icon.png",
      path: "/design"
    },
    {
      code: "collaboration",
      title: "Collaboration",
      icon: "img/icons/projectIcon/collab_icon.png",
      path: "/collaboration"
    },
    {
      code: "management",
      title: "Management",
      icon: "img/icons/projectIcon/management_icon.png",
      path: "/management"
    },
    {
      code: "innovation",
      title: "Research and Innovation",
      icon: "img/icons/projectIcon/innovation_icon.png",
      path: "/innovation"
    },
  ],
  categories: {
    commercial: [
      "Cost (Capex)",
      "Cost (Opex)",
      "Procurement and Supply Chain",
      "Contract"
    ],
    reporting: [
      "Monthly",
      "Weekly",
      "Live"
    ],
    design: [
      "Requirements",
      "Reports & Deliverables",
      "Design Models",
      "Sustainability"
    ],
    collaboration: [
      "Correspondence Management",
      "File Transfer",
      "Contact List",
      "Meetings",
      "Action Lists",
      "Risk and Issue Management",
      "Document Management",
      "Shared Calendar",
      "Interface Management",
      "Stakeholder Management"
    ],
    management: [
      "Management Plans",
      "Passport (Inductions)",
      "Resource Management",
      "Planning and Scheduling",
      "Change Control",
      "Health and Safety"
    ],
    innovation: [
      "Innovation"
    ]
  },
  selectedZone: {},
  selectedCategories: [],
  counter: 0,
  activeTabFlags: {
    insightSection: false,
    bim360Section: false,
    GISDashboardSection: false,
    GISPortalSection: false,
    simulationSection: false,
    opsSection: false,
    teamBinderSection: false,
    tab360ModelSection: false,
    pointCloudBuilding: false,
    pointCloudPrecinct: false
  },
  portfolios: [
    {
      code: "portfolio_1",
      title: "Portfolio 1"
    }
  ],
  projects: {
    portfolio_1: [
      "Project A",
      "Project B",
      "Project C",
      "Project D",
      "Project E"
    ]
  },
  projectTabs: [
    {
      zoneCode: "commercial",
      items: [
        {
          category: "Cost (Capex)",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Cost (Opex)",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Procurement and Supply Chain",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Contract",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        }
      ]
    },{
      zoneCode: "reporting",
      items: [
        {
          category: "Monthly",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Weekly",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Live",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
      ]
    },{
      zoneCode: "design",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Reports & Deliverables",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Design Models",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Sustainability",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        }
      ]
    },{
      zoneCode: "collaboration",
      items: [
        {
          category: "Correspondence Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "File Transfer",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Contact List",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Meetings",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Action Lists",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Risk and Issue Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Document Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Shared Calendar",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Interface Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Stakeholder Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        }
      ]
    },{
      zoneCode: "management",
      items: [
        {
          category: "Management Plans",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Passport (Inductions)",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Resource Management",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Planning and Scheduling",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Change Control",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
        {
          category: "Health and Safety",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        },
      ]
    },{
      zoneCode: "innovation",
      items: [
        {
          category: "Innovation",
          tabs: [
            {
              title: "INSIGHT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: ""
            },
            {
              title: "GIS",
              url: ""
            },
            {
              title: "MODEL REVIEW",
              url: ""
            }
          ]
        }
      ]
    }
  ],
  selectedPortfolio: {},
  selectedProjects: [],
  currentSelectedProject: "",
  currentSelectedSubCategory: "",
  currentSelectedProjectTab: {
    category: "",
    tabs: [
    ]
  }
}

function initialState() {
  return {
    lines: [
      {
        code: "west",
        title: "Metro West"
      },
      {
        code: "greaterWest",
        title: "Greater West"
      },
      {
        code: "northWest",
        title: "NorthWest"
      },
      {
        code: "citySouthWest",
        title: "City and SouthWest"
      },
      {
        code: "futureProjects",
        title: "Future Projects"
      }
    ],
    stations: {
      west: [
        "Example Station X",
        "Pyrmont",
        "The Bays Precinct",
        "Five Docks",
        "Burwood North",
        "North Strathfield",
        "Olympic Park",
        "Silverwater",
        "Clyde",
        "Paramatta",
        "Westmead"
      ],
      greaterWest: [],
      northWest: [],
      citySouthWest: [],
      futureProjects: []
    },
    selectedLine: {},
    selectedStations: [],
    zones: [
      {
        code: "commercial",
        title: "Commercial",
        icon: "img/icons/projectIcon/commercial_icon.png",
        path: "/commercial"
      },
      {
        code: "reporting",
        title: "Reporting",
        icon: "img/icons/projectIcon/report_icon.png",
        path: "/reporting"
      },
      {
        code: "design",
        title: "Design",
        icon: "img/icons/projectIcon/design_icon.png",
        path: "/design"
      },
      {
        code: "collaboration",
        title: "Collaboration",
        icon: "img/icons/projectIcon/collab_icon.png",
        path: "/collaboration"
      },
      {
        code: "management",
        title: "Management",
        icon: "img/icons/projectIcon/management_icon.png",
        path: "/management"
      },
      {
        code: "innovation",
        title: "Research and Innovation",
        icon: "img/icons/projectIcon/innovation_icon.png",
        path: "/innovation"
      },
    ],
    categories: {
      commercial: [
        "Cost (Capex)",
        "Cost (Opex)",
        "Procurement and Supply Chain",
        "Contract"
      ],
      reporting: [
        "Monthly",
        "Weekly",
        "Live"
      ],
      design: [
        "Requirements",
        "Reports & Deliverables",
        "Design Models",
        "Sustainability"
      ],
      collaboration: [
        "Correspondence Management",
        "File Transfer",
        "Contact List",
        "Meetings",
        "Action Lists",
        "Risk and Issue Management",
        "Document Management",
        "Shared Calendar",
        "Interface Management",
        "Stakeholder Management"
      ],
      management: [
        "Management Plans",
        "Passport (Inductions)",
        "Resource Management",
        "Planning and Scheduling",
        "Change Control",
        "Health and Safety"
      ],
      innovation: [
        "Innovation"
      ]
    },
    selectedZone: {},
    selectedCategories: [],
    counter: 0,
    activeTabFlags: {
      insightSection: false,
      bim360Section: false,
      GISDashboardSection: false,
      GISPortalSection: false,
      simulationSection: false,
      opsSection: false,
      teamBinderSection: false,
      tab360ModelSection: false,
      pointCloudBuilding: false,
      pointCloudPrecinct: false
    },
    portfolios: [
      {
        code: "portfolio_1",
        title: "Portfolio 1"
      }
    ],
    projects: {
      portfolio_1: [
        "Project A",
        "Project B",
        "Project C",
        "Project D",
        "Project E"
      ]
    },
    projectTabs: [
      {
        zoneCode: "commercial",
        items: [
          {
            category: "Cost (Capex)",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Cost (Opex)",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Procurement and Supply Chain",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Contract",
            tabs: [
              {
                title: "INSIGHT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          }
        ]
      },{
        zoneCode: "reporting",
        items: [
          {
            category: "Monthly",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Weekly",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Live",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
        ]
      },{
        zoneCode: "design",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Reports & Deliverables",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Design Models",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Sustainability",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          }
        ]
      },{
        zoneCode: "collaboration",
        items: [
          {
            category: "Correspondence Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "File Transfer",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Contact List",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Meetings",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Action Lists",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Risk and Issue Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Document Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Shared Calendar",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Interface Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Stakeholder Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          }
        ]
      },{
        zoneCode: "management",
        items: [
          {
            category: "Management Plans",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Passport (Inductions)",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Resource Management",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Planning and Scheduling",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Change Control",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
          {
            category: "Health and Safety",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          },
        ]
      },{
        zoneCode: "innovation",
        items: [
          {
            category: "Innovation",
            tabs: [
              {
                title: "INSIGHT",
                url: ""
              },
              {
                title: "INFORMATION EXCHANGE",
                url: ""
              },
              {
                title: "GIS",
                url: ""
              },
              {
                title: "MODEL REVIEW",
                url: ""
              }
            ]
          }
        ]
      }
    ],
    selectedPortfolio: {},
    selectedProjects: [],
    currentSelectedProject: "",
    currentSelectedSubCategory: "",
    currentSelectedProjectTab: {
      category: "",
      tabs: [
      ]
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedProject(state, payload) {
    state.currentSelectedProject = payload
  },
  setCurrentSelectedProjectTab(state, payload) {
    state.currentSelectedProjectTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
